export const blockIconsMapsLocalAtm = (
	<span className='material-symbols-outlined'>local_atm</span>
);
